import React, { Fragment } from "react";
import Breadcrumbs from "../../CommonElements/Breadcrumbs";
import RequestTuitionContain from "../../Component/RequestTuition";

const RequestTuition = () => {
  return (
    <Fragment>
      <Breadcrumbs parent="RequestTuition" title="Request Tuition" />
      <RequestTuitionContain />
    </Fragment>
  );
};

export default RequestTuition;
